import { Grid } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import withStyles from '@material-ui/core/styles/withStyles'
import Typography from '@material-ui/core/Typography'
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link, Route } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import NoteAddIcon from '@material-ui/icons/NoteAdd'


import styles from '../../../resources/theme/global'
import { renderRoute } from '../../../util/utils'
import { fetchCompany } from '../CompaniesActions'
import { getCompanyListData } from '../CompaniesReducer'

import { makeReport } from '../CompaniesActions' //


import Edit from './Edit'
// import Filter from './Filter'
import List from './List'
import New from './New'

class Company extends Component {
  componentDidMount() {
    this.props.fetchCompany()
  }

  render() {
    const { classes, permissions } = this.props
    

    return (
      <>
        <Grid
          container
          className={classes.pageHead}
          spacing={1}
          alignItems="center"
        >
          <Grid item xs>
            <Typography variant="h4" color="secondary">
              Empresas
            </Typography>
          </Grid>
          <Grid item>{/* <Filter classes={classes} /> */}</Grid>
          <Grid item>
            <Button
              color="primary"
              type="button"
              onClick={() => this.props.makeReport(this.props.items)}
            >
              <NoteAddIcon className={classes.btnIcon} /> Relatório
            </Button>
          </Grid>
          <Grid item>
            {renderRoute(['create-companies'], permissions) && (
              <Button
                color="primary"
                variant="contained"
                component={Link}
                to="/company/new"
              >
                <AddCircleOutlineIcon className={classes.btnIcon} /> Cadastrar
              </Button>
            )}
          </Grid>
        </Grid>

        {renderRoute(['create-companies'], permissions) && (
          <Route path="/company/new" component={New} />
        )}
        {renderRoute(['update-companies'], permissions) && (
          <Route path="/company/:id/edit" component={Edit} />
        )}

        <List {...this.props} />
      </>
    )
  }
}

const mapStateToProps = state => ({
  ...getCompanyListData(state),
  permissions: state.auth.permissions || [],
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchCompany, makeReport
    },
    dispatch
  )
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Company))
